/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Loading_AriaInputs */

const en_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const de_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const fr_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const es_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const it_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const nl_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const pl_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const fi_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const da_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

const sv_portal_scanner_loading_aria = /** @type {(inputs: Portal_Scanner_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading portal scanner`)
};

/**
* | output |
* | --- |
* | "Loading portal scanner" |
*
* @param {Portal_Scanner_Loading_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_loading_aria = /** @type {((inputs?: Portal_Scanner_Loading_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Loading_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_loading_aria(inputs)
	if (locale === "fr") return fr_portal_scanner_loading_aria(inputs)
	if (locale === "es") return es_portal_scanner_loading_aria(inputs)
	if (locale === "it") return it_portal_scanner_loading_aria(inputs)
	if (locale === "nl") return nl_portal_scanner_loading_aria(inputs)
	if (locale === "pl") return pl_portal_scanner_loading_aria(inputs)
	if (locale === "fi") return fi_portal_scanner_loading_aria(inputs)
	if (locale === "da") return da_portal_scanner_loading_aria(inputs)
	if (locale === "sv") return sv_portal_scanner_loading_aria(inputs)
	return en_portal_scanner_loading_aria(inputs)
});